import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { IoMailOpenOutline } from "react-icons/io5";
import { IoLogoUsd } from "react-icons/io5";
import { AiFillQuestionCircle } from "react-icons/ai";
import {
  FaArrowCircleLeft,
  FaArrowCircleRight,
  FaRegEdit,
  FaTrashAlt,
  FaRupeeSign,
} from "react-icons/fa";

import AssignToDetails from "./SubComponent/AssignToDetails";
import BuyerManagementDetails from "./SubComponent/BuyerManagementDetails";
import Contacts from "./SubComponent/Contacts";
import GeoDetails from "./SubComponent/GeoDetails";
import ExecutivesDetails from "./SubComponent/ExecutivesDetails";
import OtherBusinessDetails from "./SubComponent/OtherBusinessDetails";
import FilesAttachments from "./SubComponent/FilesAttachement";
import Security from "./SubComponent/Security";
// import {  } from "./";
import {
  Link,
  Outlet,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";
import axios from "axios";

import All_Active_OSP from "../../ActiveOSPList/All_active_OSP_List";
import BasicDetails from "../BasicDetails/BasicDetails"
// import AssignedDetails from "../../AddOSP/SubComponent/"
// import AssignedDetails from "./SubCompoenents/AssignToDetails";

const ViewBuyerDetails = () => {
  // const { id } = useParams();
  // localStorage.setItem("id", id);
  const id = localStorage.getItem("id");
  const [data, setData] = useState({});
  const [dynamicFields, setDynamicFields] = useState([]);
  const location = useLocation();
  const [Showon, setShowon] = useState(true);
    const [showModal, setShowModal] = useState(false);
  // console.log(id);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `https://hb40wwcn-8000.inc1.devtunnels.ms/addbuyer/buyer-details/${id}/`
        );
        setData(res.data); // Set the response object directly
        // console.log("DATA:", res.data);
      } catch (error) {
        console.error("Error fetching buyer details:", error);
      }
    };

    fetchData();
  }, [id]);
  // console.log("UseState DATA", data);
  const navigate = useNavigate();
  const handleUpdate = async () => {
    try {
      const res = await axios.get(
        `https://hb40wwcn-8000.inc1.devtunnels.ms/buyer_settings/custom-fields/`
      );
      setDynamicFields(res.data);
      console.log(res.data);
    } catch (error) {
      console.error("Error fetching buyer details:", error);
    }
    navigate("/admin-dashboard/update-osp", {
      state: { buyerData: data, dynamicFields: dynamicFields },
    });
  };
  const handleDelete = async () => {
    // const confirmDelete = window.confirm(
    //   "Are you sure you want to delete this buyer?"
    // );
   const confirmDelete=null
    setShowModal(true);
    console.log(confirmDelete);
    if (!confirmDelete) return; // Exit if the user cancels the action

    try {
      console.log("Hello");
      const res = await axios.delete(
        `https://hb40wwcn-8000.inc1.devtunnels.ms/addbuyer/delete-buyer-details/${id}/`
      );
      console.log("Delete Response:", res.data);

      // Navigate back to the buyer list page after successful deletion
      navigate("/admin-dashboard/buyer/");
    } catch (error) {
      console.error("Error deleting buyer details:", error);

      // Optionally, show an error message to the user
      alert("Failed to delete the buyer. Please try again.");
    }
  };
  return (
    <div className="border-2 border-gray-200 rounded-2xl p-2">
      <div className="border-b pb-2 flex justify-between items-center ">
        <h1 className="text-xl text-gray-600 font-semibold">Osp Details</h1>

        <div className="flex items-center gap-4">
          <button className="flex gap-1 items-center bg-[#25d366] text-white px-4 py-2 rounded-md">
            <FaWhatsapp /> Whats App
          </button>
          <button className="flex gap-1 items-center bg-[#333333] text-white px-4 py-2 rounded-md">
            <BiPhoneCall /> Call
          </button>
          <div className="flex items-center border border-oceanBlue text-oceanBlue rounded-md">
            <span className="bg-oceanBlue py-2 px-2 text-white text-xl">
              <IoMailOpenOutline />
            </span>
            <button className="flex gap-1 items-center px-2">Send Email</button>
          </div>
        </div>

        <div className="flex gap-2">
          <button
            className="bg-[#333333] text-white p-2 text-xl flex justify-center text-center rounded-md"
            onClick={handleUpdate}
          >
            <FaRegEdit />
          </button>
          <button
            onClick={handleDelete}
            className="bg-blood p-2 rounded-md text-white text-xl"
          >
            <FaTrashAlt />
          </button>
        </div>
      </div>

      {/* TAB HEADERS */}
      <div className="flex gap-5 mt-5">
        <p
          onClick={() => setShowon(true)}
          className={`flex w-fit items-center gap-2 text-md font-medium cursor-pointer pb-1 border-b-[3px] ${
            Showon
              ? "text-blood border-blood"
              : "text-[#667085] border-transparent"
          }`}
        >
          Details
        </p>

        <p
          onClick={() => setShowon(false)}
          className={`flex w-fit items-center gap-2 text-md font-medium cursor-pointer pb-1 border-b-[3px] ${
            !Showon
              ? "text-blood border-blood"
              : "text-[#667085] border-transparent"
          }`}
        >
          Products
        </p>
      </div>

      {/* CONTENT SECTION */}
      {Showon ? (
        <div>
          <div className="py-8 flex gap-5 justify-center">
            <p className="flex items-center bg-oceanBlue text-white px-4 py-2 rounded-md">
              Sellable Price of this Buyer in INR:
              <FaRupeeSign /> 0
            </p>
            <p className="flex items-center bg-oceanBlue text-white px-4 py-2 rounded-md">
              Sellable Price of this Buyer in USD:
              <IoLogoUsd /> 0
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <Contacts data={data} />
            <AssignToDetails />
            <BuyerManagementDetails data={data} />
            <BasicDetails data={data} />
            <GeoDetails data={data} />
            <ExecutivesDetails data={data} />
            <OtherBusinessDetails data={data} />
            <FilesAttachments data={data} />
            <Security />
          </div>
        </div>
      ) : (
        <All_Active_OSP />
      )}
      {/* Modal */}
      {showModal && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col  py-5 text-center relative">
            <div className="flex w-full justify-center">
              <AiFillQuestionCircle className="text-6xl text-red-700 text-center" />
            </div>
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-md font-semibold">
                Do you want to delete this buyer contact ?
              </h3>
            </div>

            <div className="flex justify-center gap-5  ">
              <button
                onClick={() => setShowModal(false)}
                className="border border-b-teal-950 cousor-pointer text-red-700 px-4 py-1 rounded"
              >
                Cancel
              </button>
              <button
                 onClick={() => setShowModal(false)}
                className="bg-red-700  text-white px-4 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewBuyerDetails;